module.exports = __webpack_public_path__ + "img/oog_owol.fcc9eb53.png";